import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { filter, map, Observable, take } from 'rxjs'
import { AppState } from '../store/state/app.state'
import { getEnabledModules } from '../store/selector/initialize.selector'
import { GlobalConstants } from '../constants/global-constants'

export const ModuleRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | import('@angular/router').UrlTree> => {
  const store = inject(Store<AppState>)
  const router = inject(Router)

  const requiredModule: string = route.data['requiredModule']
  const fallback = router.createUrlTree([`/${GlobalConstants.ROUTING.PROFILE}`])

  return store.select(getEnabledModules).pipe(
    filter(modules => modules !== null && modules !== undefined),
    take(1),
    map(modules => {
      if (!requiredModule) return true
      return modules.includes(requiredModule) ? true : fallback
    })
  )
}
